import React, { Component } from "react";
import logotamanDEV from "assets/frontend/images/BrandIcon.svg";
import { Link } from "react-router-dom";

export default class BrandIcon extends Component {
  render() {

    return (
      <div> 
        <Link className="navbar-brand" to="/">
          <img src={logotamanDEV} width="140px" alt="logo-tamandev" />
        </Link>
      </div>
    );
  }
}
